import React from 'react'

const MainContentPrivacy = () => {
  return (
    <div   className='flex flex-col   justify-center'   >

<div className=" mt-3 flex justify-center items-center">
      <div className="max-w-2xl bg-white ">
        <h1 className="text-2xl font-semibold mb-4">Privacy Policy</h1>

        <p className="mb-4">
          This privacy policy applies between you, the User of this Website and Makfry UK Ltd, the owner and provider
          of this Website. Makfry UK Ltd takes the privacy of your information very seriously. This privacy policy applies
          to our use of any and all Data collected by us or provided by you in relation to your use of the Website.
        </p>
        <p className="mb-4">
          This privacy policy should be read alongside, and in addition to, our Terms and Conditions, which can be found
          at: <a href="https://canmac.co.uk/policies/terms-of-service" className="text-blue-500">Terms of Service</a>.
        </p>
        <p>
          Please read this privacy policy carefully.
        </p>
      </div>
    </div>


<div className=" min-h-screen flex justify-center items-center">
      <div className="max-w-2xl bg-white ">
        <h2 className="text-2xl font-semibold mb-4">Definitions and Interpretation</h2>

        <p className="mb-4">
          In this privacy policy, the following definitions are used:
        </p>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Data</h3>
          <p className="mb-2">
            Collectively all information that you submit to Makfry UK Ltd via the Website.
            This definition incorporates, where applicable, the definitions provided in the Data Protection Laws.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Cookies</h3>
          <p className="mb-2">
            A small text file placed on your computer by this Website when you visit certain parts of the Website
            and/or when you use certain features of the Website. Details of the cookies used by this Website
            are set out in the clause below (Cookies).
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Data Protection Laws</h3>
          <p className="mb-2">
            Any applicable law relating to the processing of personal data, including but not limited to the Directive 96/46/EC (Data Protection Directive) or the GDPR,
            and any national implementing laws, regulations and secondary legislation, for as long as the GDPR is effective in the UK.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">GDPR</h3>
          <p className="mb-2">
            The General Data Protection Regulation (EU) 2016/679.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Makfry UK Ltd, or us</h3>
          <p className="mb-2">
            Makfry UK Ltd of Northfield House Farm, Rugby Road, Lutterworth, LE17 4HT.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">UK and EU Cookie Law</h3>
          <p className="mb-2">
            The Privacy and Electronic Communications (EC Directive) Regulations 2003 as amended by the Privacy and Electronic Communications (EC Directive) (Amendment) Regulations 2011.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">User or you</h3>
          <p className="mb-2">
            Any third party that accesses the Website and is not either (i) employed by Makfry UK Ltd and acting in the course of their employment or (ii) engaged as a consultant or otherwise providing services to Makfry UK Ltd and accessing the Website in connection with the provision of such services.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-xl font-semibold mb-2">Website</h3>
          <p className="mb-2">
            The website that you are currently using, https://canmac.co.uk, and any sub-domains of this site unless expressly excluded by their own terms and conditions.
          </p>
        </div>

        <p className="mb-4">
          In this privacy policy, unless the context requires a different interpretation:
        </p>

        <ul className="list-disc list-inside mb-6 pl-4">
          <li>The singular includes the plural and vice versa;</li>
          <li>References to sub-clauses, clauses, schedules or appendices are to sub-clauses, clauses, schedules or appendices of this privacy policy;</li>
          <li>A reference to a person includes firms, companies, government entities, trusts and partnerships;</li>
          <li>“Including” is understood to mean “including without limitation”;</li>
          <li>Reference to any statutory provision includes any modification or amendment of it;</li>
          <li>The headings and sub-headings do not form part of this privacy policy.</li>
        </ul>
      </div>
    </div>

    <div class=" mx-auto ">
        <div class="max-w-2xl bg-white ">
            <h1 class="text-2xl font-semibold mb-4">Scope of this Privacy Policy</h1>
            <p class="mb-6">This privacy policy applies only to the actions of Makfry UK Ltd and Users with respect to this Website. It does not extend to any websites that can be accessed from this Website including, but not limited to, any links we may provide to social media websites.</p>
            
            <h2 class="text-lg font-semibold mb-4">For purposes of the applicable Data Protection Laws</h2>
            <p class="mb-6">Makfry UK Ltd is the “data controller”. This means that Makfry UK Ltd determines the purposes for which and the manner in which, your Data is processed.</p>
            
            <h2 class="text-lg font-semibold mb-4">Data Collected</h2>
            <p class="mb-6">We may collect the following Data, which includes personal Data, from you:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>name;</li>
                <li>contact Information such as email addresses and telephone numbers;</li>
                <li>IP address (automatically collected);</li>
                <li>web browser type and version (automatically collected);</li>
                <li>operating system (automatically collected);</li>
                <li>a list of URLs starting with a referring site, your activity on this Website, and the site you exit to (automatically collected);</li>
            </ul>
            
            <h2 class="text-lg font-semibold mb-4">How We Collect Data</h2>
            <p class="mb-6">We collect Data in the following ways:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>data is given to us by you; and</li>
                <li>data is collected automatically.</li>
            </ul>
            
            <h2 class="text-lg font-semibold mb-4">Data Given to Us by You</h2>
            <p class="mb-6">Makfry UK Ltd will collect your Data in a number of ways, for example:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>when you contact us through the Website, by telephone, post, e-mail or through any other means;</li>
                <li>when you register with us and set up an account to receive our products/services;</li>
                <li>when you make payments to us, through this Website or otherwise;</li>
            </ul>
            
            <p class="mb-6">We do not store credit card details nor do we share customer details with any 3rd parties.</p>
            
            <h2 class="text-lg font-semibold mb-4">Data Collected Automatically</h2>
            <p class="mb-6">To the extent that you access the Website, we will collect your Data automatically, for example:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>we automatically collect some information about your visit to the Website. This information helps us to make improvements to Website content and navigation and includes your IP address, the date, times and frequency with which you access the Website and the way you use and interact with its content;</li>
                <li>we will collect your Data automatically via cookies, in line with the cookie settings on your browser. For more information about cookies, and how we use them on the Website, see the section below, headed “Cookies”.</li>
            </ul>
        </div>
    </div>

    <div class="container mx-auto ">
        <div class="max-w-2xl bg-white mx-auto">
            <h1 class="text-2xl font-semibold mb-4">Our Use of Data</h1>
            <p class="mb-6">Any or all of the above Data may be required by us from time to time in order to provide you with the best possible service and experience when using our Website. Specifically, Data may be used by us for the following reasons:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>internal record keeping;</li>
                <li>improvement of our products/services;</li>
                <li>transmission by email of marketing materials that may be of interest to you;</li>
            </ul>
            
            <p class="mb-6">We may use your Data for the above purposes if we deem it necessary to do so for our legitimate interests. If you are not satisfied with this, you have the right to object in certain circumstances (see the section headed “Your rights” below).</p>
            
            <h2 class="text-lg font-semibold mb-4">Consent for Marketing</h2>
            <p class="mb-6">For the delivery of direct marketing to you via e-mail, we’ll need your consent, whether via an opt-in or soft-opt-in:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>soft opt-in consent is a specific type of consent which applies when you have previously engaged with us;</li>
                <li>for other types of e-marketing, we are required to obtain your explicit consent;</li>
            </ul>
            
            <p class="mb-6">If you are not satisfied with our approach to marketing, you have the right to withdraw consent at any time.</p>
            
            <h2 class="text-lg font-semibold mb-4">Account Registration and Legal Basis</h2>
            <p class="mb-6">When you register with us and set up an account to receive our services, the legal basis for this processing is the performance of a contract between you and us and/or taking steps, at your request, to enter into such a contract.</p>
            
            <h2 class="text-lg font-semibold mb-4">Data Sharing</h2>
            <p class="mb-6">We may share your Data with the following groups of people for the following reasons:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>our employees, agents and/or professional advisors – to obtain advice from professional advisers;</li>
                <li>third party payment providers who process payments made over the Website – to enable third party payment providers to process user payments and refunds;</li>
                <li>relevant authorities – to facilitate the detection of crime or the collection of taxes or duties;</li>
            </ul>
            
            <h2 class="text-lg font-semibold mb-4">Data Security</h2>
            <p class="mb-6">We will use technical and organisational measures to safeguard your Data, for example:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>access to your account is controlled by a password and a user name that is unique to you;</li>
                <li>we store your Data on secure servers;</li>
                <li>we are certified to PCI DSS;</li>
            </ul>
            
            <p class="mb-6">Technical and organisational measures include measures to deal with any suspected data breach.</p>
            
            <p>If you want detailed information on how to protect your information and your devices against online problems, please visit <a href="https://www.getsafeonline.org" class="text-blue-500">www.getsafeonline.org</a>.</p>
        </div>
    </div>
    <div class="container mx-auto py-8">
        <div class="max-w-2xl bg-white mx-auto">
            <h1 class="text-2xl font-semibold mb-4">Data Retention</h1>
            <p class="mb-6">Unless a longer retention period is required or permitted by law, we will only hold your Data on our systems for the period necessary to fulfil the purposes outlined in this privacy policy or until you request that the Data be deleted.</p>
            <p class="mb-6">Even if we delete your Data, it may persist on backup or archival media for legal, tax or regulatory purposes.</p>
            
            <h2 class="text-lg font-semibold mb-4">Your Rights</h2>
            <p class="mb-6">You have the following rights in relation to your Data:</p>
            <ul class="list-disc pl-6 mb-6">
                <li>Right to access – the right to request copies of the information we hold about you;</li>
                <li>Right to correct – the right to have your Data rectified if it is inaccurate or incomplete;</li>
                <li>Right to erase – the right to request that we delete or remove your Data from our systems;</li>
                <li>Right to restrict our use of your Data – the right to “block” us from using your Data or limit the way in which we can use it;</li>
                <li>Right to data portability – the right to request that we move, copy or transfer your Data;</li>
                <li>Right to object – the right to object to our use of your Data including where we use it for our legitimate interests.</li>
            </ul>
            
            <p class="mb-6">To make enquiries, exercise any of your rights set out above, or withdraw your consent to the processing of your Data, please contact us via this e-mail address: info@canmac.co.uk.</p>
            
            <p class="mb-6">If you are not satisfied with the way a complaint you make in relation to your Data is handled by us, you may be able to refer your complaint to the relevant data protection authority.</p>
            
            <p class="mb-6">It is important that the Data we hold about you is accurate and current. Please keep us informed if your Data changes during the period for which we hold it.</p>
            
            <h2 class="text-lg font-semibold mb-4">Links to Other Websites</h2>
            <p class="mb-6">This Website may, from time to time, provide links to other websites. We have no control over such websites and are not responsible for the content of these websites. This privacy policy does not extend to your use of such websites. You are advised to read the privacy policy or statement of other websites prior to using them.</p>
            
            <h2 class="text-lg font-semibold mb-4">Changes of Business Ownership and Control</h2>
            <p class="mb-6">Makfry UK Ltd may, from time to time, expand or reduce our business and this may involve the sale and/or the transfer of control of all or part of Makfry UK Ltd. Data provided by Users will, where it is relevant to any part of our business so transferred, be transferred along with that part and the new owner or newly controlling party will, under the terms of this privacy policy, be permitted to use the Data for the purposes for which it was originally supplied to us.</p>
            <p class="mb-6">We may also disclose Data to a prospective purchaser of our business or any part of it.</p>
            
            <p class="mb-6">In the above instances, we will take steps with the aim of ensuring your privacy is protected.</p>
            
            <h2 class="text-lg font-semibold mb-4">Cookies</h2>
            <p class="mb-6">This Website may place and access certain Cookies on your computer. Makfry UK Ltd uses Cookies to improve your experience of using the Website and to improve our range of products. Makfry UK Ltd has carefully chosen these Cookies and has taken steps to ensure that your privacy is protected and respected at all times.</p>
            
            <p class="mb-6">All Cookies used by this Website are used in accordance with current UK and EU Cookie Law.</p>
            
            <p class="mb-6">Before the Website places Cookies on your computer, you will be presented with a message bar requesting your consent to set those Cookies. By giving your consent to the placing of Cookies, you are enabling Makfry UK Ltd to provide a better experience and service to you. You may, if you wish, deny consent to the placing of Cookies; however, certain features of the Website may not function fully or as intended.</p>
            
            <h3 class="text-lg font-semibold mb-2">Types of Cookies</h3>
            <p class="mb-6">This Website may place the following Cookies:</p>
            <ul class="list-disc pl-6 mb-6">
                <li><strong>Strictly necessary cookies:</strong> These are cookies required for the operation of our website, such as log-in and e-billing services.</li>
                <li><strong>Analytical/performance cookies:</strong> They help us count the number of visitors and improve the website's performance.</li>
                <li><strong>Functionality cookies:</strong> Used to recognize you when you return to the website, enabling personalization.</li>
                <li><strong>Targeting cookies:</strong> Record your visit, pages viewed, and links followed to make our website's advertising more relevant.</li>
            </ul>
            
            <h3 class="text-lg font-semibold mb-2">Managing Cookies</h3>
            <p class="mb-6">You can choose to enable or disable Cookies in your internet browser. By default, most internet browsers accept Cookies, but this can be changed. You can also choose to delete Cookies at any time; however, this may affect certain features of the Website.</p>
            
            <p class="mb-6">It's recommended to ensure that your internet browser is up-to-date and consult the browser's help menu if you're unsure about adjusting privacy settings.</p>
            
            <p class="mb-6">For more information about cookies and how to manage them, please visit <a href="https://www.aboutcookies.org/" class="text-blue-500">www.aboutcookies.org</a>.</p>
        </div>
    </div>


    <div class="container mx-auto ">
        <div class="max-w-2xl bg-white  mx-auto">
            <h2 class="text-lg font-semibold mb-4">General</h2>
            <p class="mb-6">You may not transfer any of your rights under this privacy policy to any other person. We may transfer our rights under this privacy policy where we reasonably believe your rights will not be affected.</p>
            <p class="mb-6">If any court or competent authority finds that any provision of this privacy policy (or part of any provision) is invalid, illegal or unenforceable, that provision or part provision will, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this privacy policy will not be affected.</p>
            <p class="mb-6">Unless otherwise agreed, no delay, act, or omission by a party in exercising any right or remedy will be deemed a waiver of that, or any other, right or remedy.</p>
            <p class="mb-6">This Agreement will be governed by and interpreted according to the law of England and Wales. All disputes arising under the Agreement will be subject to the exclusive jurisdiction of the English and Welsh courts.</p>
            
            <h2 class="text-lg font-semibold mb-4">Privacy and SMS Marketing</h2>
            <p class="mb-6">We value your privacy and the information you consent to share in relation to our SMS marketing service. We use this information to send you text notifications (for your order, including abandoned checkout reminders), text marketing offers, and transactional texts, including requests for reviews from us.</p>
            
            <p class="mb-6">Our website uses cookies to keep track of items you put into your shopping cart, including when you have abandoned your checkout. This information is used to determine when to send cart reminder messages via SMS.</p>
            
            <h2 class="text-lg font-semibold mb-4">Changes to This Privacy Policy</h2>
            <p class="mb-6">Makfry UK Ltd reserves the right to change this privacy policy as we may deem necessary from time to time or as may be required by law. Any changes will be immediately posted on the Website and you are deemed to have accepted the terms of the privacy policy on your first use of the Website following the alterations.</p>
            
            <p class="mb-6">You may contact Makfry UK Ltd by email at <a href="mailto:info@canmac.co.uk" class="text-blue-500">info@canmac.co.uk</a>.</p>
        </div>
    </div>


    </div>
  )
}

export default MainContentPrivacy